import { Default, Detail,  List } from "./views";
import { ApplyAction } from "./wizards";



const Module = {
    name: "zohoaccount",
    defaultRoutePath: "/zoho/account",
    menuItemScope: "sync",
    menuItemName: "zohoaccount",

    routes: [
        {
            path: "/zoho/account",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Default,
                },
                {
                    path: "list",
                    Component: List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "applyAction",
            Component: ApplyAction,
        },
        {
            path: "detail",
            Component: Detail,
        },
        
        // {
        //     path: "create",
        //     Component: Create,
        // },
    ],
    
}

export default Module;
